export default __webpack_public_path__ + "0094146a0505298ed06a0ef3af075f2e.ttf";